import logo from "./css/images/logos/Nucleus.png";

export const MIN_DESKTOP_WIDTH = 960;

export const nucleus = {
    primary: "#f78f21",
    secondary: "#70655d",
    tertiary: "#fff",
    disabled: "#eee",
    minWidth: `${MIN_DESKTOP_WIDTH}px`,
    maxWidth: "959px",
    topBarHeightDesktop: "116px",
    topBarHeightMobile: "76px",
    logo
};

export const anonymised = {
    primary: "#70655d",
    secondary: "#000",
    tertiary: "#fff",
    disabled: "#eee",
    minWidth: "960px",
    maxWidth: "959px",
    topBarHeightDesktop: "116px",
    topBarHeightMobile: "76px"
};
